(function () {
  const STORAGE_KEY = "vatMode";
  const DEFAULT_MODE = "excl"; // Företag som standard (originalpris = EXKL moms)
  const DEFAULT_VAT = 0.25;

  // Format: 12 500.00 kr (punkt som decimal)
  function formatMoneySEK(amount) {
    const fixed = amount.toFixed(2);
    const parts = fixed.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(".") + " kr";
  }

  function getMode() {
    return localStorage.getItem(STORAGE_KEY) || DEFAULT_MODE;
  }

  // Originalpriset i DOM (data-price-cents / data-compare-at-cents) = EXKL moms
  function convertFromExVat(priceExVat, vatRate, mode) {
    return mode === "incl" ? priceExVat * (1 + vatRate) : priceExVat;
  }

  function parsePriceText(text) {
    if (!text) return NaN;

    return parseFloat(
      text
        .replace(/kr/gi, "")
        .replace(/\s/g, "")
        .replace(",", ".")
        .trim()
    );
  }

  let isApplying = false;
  let rafScheduled = false;

  function scheduleApply() {
    if (rafScheduled) return;
    rafScheduled = true;
    requestAnimationFrame(() => {
      rafScheduled = false;
      applyMode(getMode());
    });
  }

  function applyMode(mode) {
    if (isApplying) return;
    isApplying = true;

    try {
      // Regular + sale
      document.querySelectorAll(".js-vat-price").forEach((el) => {
        const cents = parseInt(el.dataset.priceCents, 10);
        if (Number.isNaN(cents)) return;

        const vatRate = parseFloat(el.dataset.vatRate || DEFAULT_VAT);
        const priceExVat = cents / 100;
        const newPrice = convertFromExVat(priceExVat, vatRate, mode);

        const nextText = formatMoneySEK(newPrice);
        if (el.textContent !== nextText) el.textContent = nextText;
      });

      // Compare-at (struket pris)
      document.querySelectorAll(".js-vat-compare").forEach((el) => {
        const cents = parseInt(el.dataset.compareAtCents, 10);
        if (Number.isNaN(cents) || cents <= 0) return;

        const vatRate = parseFloat(el.dataset.vatRate || DEFAULT_VAT);
        const priceExVat = cents / 100;
        const newPrice = convertFromExVat(priceExVat, vatRate, mode);

        const s = el.matches("s") ? el : el.querySelector("s");
        if (!s) return;

        const nextText = formatMoneySEK(newPrice);
        if (s.textContent !== nextText) s.textContent = nextText;
      });

      // Momslabel (Exkl/Inkl)
      document.querySelectorAll(".js-vat-label").forEach((el) => {
        const nextText = mode === "incl" ? "Inkl. moms" : "Exkl. moms";
        if (el.textContent !== nextText) el.textContent = nextText;
      });

      // Secondary text i parentes
      document.querySelectorAll(".js-vat-secondary").forEach((el) => {
        const cents = parseInt(el.dataset.priceCents, 10);
        if (Number.isNaN(cents)) return;

        const vatRate = parseFloat(el.dataset.vatRate || DEFAULT_VAT);
        const priceEx = cents / 100;

        const nextText =
          mode === "incl"
            ? "(" + formatMoneySEK(priceEx) + " exkl. moms)"
            : "(" + formatMoneySEK(priceEx * (1 + vatRate)) + " inkl. moms)";

        if (el.textContent !== nextText) el.textContent = nextText;
      });

      // Fristående priser med egna fasta värden
      // Exempel:
      // <span class="VAT-TOGGLE" data-excl="96" data-incl="59">96</span>
      document.querySelectorAll(".VAT-TOGGLE").forEach((el) => {
        const excl = el.dataset.excl;
        const incl = el.dataset.incl;

        if (!excl || !incl) return;

        const nextText = mode === "incl" ? incl : excl;

        if (el.textContent !== nextText) {
          el.textContent = nextText;
        }
      });

      // Cart drawer-priser
      document.querySelectorAll(".drawer__inner .price").forEach((el) => {
        let priceExcl = parseFloat(el.dataset.priceExcl || "");

        if (Number.isNaN(priceExcl)) {
          priceExcl = parsePriceText(el.textContent);
          if (Number.isNaN(priceExcl)) return;
          el.dataset.priceExcl = priceExcl;
        }

        const vatRate = parseFloat(el.dataset.vatRate || DEFAULT_VAT);
        const newPrice = convertFromExVat(priceExcl, vatRate, mode);
        const nextText = formatMoneySEK(newPrice);

        if (el.textContent.trim() !== nextText) {
          el.textContent = nextText;
        }
      });

      // Cart drawer subtotal
      document.querySelectorAll(".drawer__inner .totals__subtotal-value").forEach((el) => {
        let subtotalExcl = parseFloat(el.dataset.subtotalExcl || "");

        if (Number.isNaN(subtotalExcl)) {
          subtotalExcl = parsePriceText(el.textContent);
          if (Number.isNaN(subtotalExcl)) return;
          el.dataset.subtotalExcl = subtotalExcl;
        }

        const vatRate = parseFloat(el.dataset.vatRate || DEFAULT_VAT);
        const newSubtotal = convertFromExVat(subtotalExcl, vatRate, mode);
        const nextText = formatMoneySEK(newSubtotal);

        if (el.textContent.trim() !== nextText) {
          el.textContent = nextText;
        }
      });

      // Aktiv knapp
      document.querySelectorAll(".vat-option").forEach((b) => b.classList.remove("is-active"));
      if (mode === "incl") {
        document.getElementById("privateBtn")?.classList.add("is-active");
      } else {
        document.getElementById("companyBtn")?.classList.add("is-active");
      }
    } finally {
      isApplying = false;
    }

    const topbar = document.querySelector(".topbar");
    if (topbar) {
      if (mode === "incl") {
        topbar.classList.add("privat");
      } else {
        topbar.classList.remove("privat");
      }
    }
  }

  function bindButtons() {
    const privateBtn = document.getElementById("privateBtn");
    const companyBtn = document.getElementById("companyBtn");
    if (!privateBtn || !companyBtn) return;

    if (privateBtn.dataset.vatBound === "1") return;
    privateBtn.dataset.vatBound = "1";
    companyBtn.dataset.vatBound = "1";

    privateBtn.addEventListener("click", () => {
      localStorage.setItem(STORAGE_KEY, "incl");
      scheduleApply();
    });

    companyBtn.addEventListener("click", () => {
      localStorage.setItem(STORAGE_KEY, "excl");
      scheduleApply();
    });
  }

  function hasRelevantNode(node) {
    if (!(node instanceof Element)) return false;

    if (
      node.matches(
        ".js-vat-price, .js-vat-compare, .js-vat-label, .js-vat-secondary, .VAT-TOGGLE, .drawer__inner .price, .drawer__inner .totals__subtotal-value, #privateBtn, #companyBtn"
      )
    ) {
      return true;
    }

    return !!node.querySelector(
      ".js-vat-price, .js-vat-compare, .js-vat-label, .js-vat-secondary, .VAT-TOGGLE, .drawer__inner .price, .drawer__inner .totals__subtotal-value, #privateBtn, #companyBtn"
    );
  }

  function observeDom() {
    const observer = new MutationObserver((mutations) => {
      if (isApplying) return;

      let relevant = false;

      for (const m of mutations) {
        if (m.type !== "childList") continue;
        if (m.addedNodes && m.addedNodes.length) {
          for (const n of m.addedNodes) {
            if (hasRelevantNode(n)) {
              relevant = true;
              break;
            }
          }
        }
        if (relevant) break;
      }

      if (relevant) {
        bindButtons();
        scheduleApply();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    bindButtons();

    scheduleApply();
    setTimeout(scheduleApply, 50);
    window.addEventListener("load", scheduleApply);

    document.addEventListener("shopify:section:load", () => {
      bindButtons();
      scheduleApply();
    });

    observeDom();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();